import * as React from "react";
import { isDatesEqual } from "src/utils/dateUtils";

const formatDay = (date: Date): string =>
  date.toLocaleDateString("en-US", {
    weekday: "long",
  });

const renderDate = (date: Date): React.JSX.Element => (
  <div className="d-flex flex-column align-items-center gap-1">
    <div className="fs-14 fw-regular">{date.toLocaleString("en-US", { month: "short" }).toUpperCase()}</div>
    <h4 className="fw-bold">{date.toLocaleString("en-US", { day: "2-digit" })}</h4>
    <div className="fw-medium monospace-numbers">{date.toLocaleString("en-US", { year: "numeric" })}</div>
  </div>
);

interface EventDateDisplayProps {
  startDate: Date;
  endDate: Date;
  color?: string;
}

export const EventDateDisplay: React.FC<EventDateDisplayProps> = ({ startDate, endDate, color = "primary" }) => {
  const hasDifferentDate = !isDatesEqual(startDate, endDate);
  const colorClass = color === "primary" ? "bg-lvl4" : `bg-${color}`;
  return (
    <div className="d-flex gap-2 align-items-center mt-n4 ms-n2">
      <div className={`d-flex gap-2 align-items-center px-2 py-3 ${colorClass}`}>
        {hasDifferentDate ? (
          <>
            <div className="text-center">{renderDate(startDate)}</div>
            <h6>-</h6>
            <div className="text-center">{renderDate(endDate)}</div>
          </>
        ) : (
          <div className="text-center">{renderDate(startDate)}</div>
        )}
      </div>
      <div className="d-flex flex-column">
        <div className="fs-18 fw-medium">
          {hasDifferentDate ? `${formatDay(startDate)} to ${formatDay(endDate)}` : formatDay(startDate)}
        </div>
      </div>
    </div>
  );
};
